












































import {Component, Mixins} from 'vue-property-decorator';
import TextInput from '@/components/input/TextInput.vue';
import DataTable from '@/components/table/DataTable.vue';
import IconButton from '@/components/button/IconButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import {
  CaseDeviceComponentCodeListInfo,
  CaseDeviceComponentCodeDictionaryDialogRequest,
  CaseDeviceComponentCodeDictionaryDialogResponse
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CaseApi from '@/api/CaseApi';
import CodeSearchDialogMixin from '@/components/dialog/CodeSearchDialogMixin.vue';

@Component({
  mixins: [CodeSearchDialogMixin],
  components: {
    CommonPromptDialog,
    DataTable,
    TextInput,
    IconButton,
    CommonButton,
    CommonPaginatedTable
  }
})
export default class CaseDeviceComponentCodeSelectDialog extends Mixins(CodeSearchDialogMixin) {
  protected values: CaseDeviceComponentCodeListInfo[] = [];
  protected onSelect: (data: CaseDeviceComponentCodeListInfo) => void;
  
  get getColumns() {
    const columnIds = ['level3Term', 'level2Term', 'level1Term', 'fdaCode', 'imdrfCode'];
    return this.getTableHeaderColumns('deviceCode.caseDeviceCodeSelectDialog', columnIds);
  }
  
  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showCaseDeviceComponentCodeSelectDialog', (params: CaseDeviceComponentCodeDictionaryDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideCaseDeviceComponentCodeSelectDialog', () => this.close());
  }
  
  public retrieve(pageNo: number, rowCount: number) {
    if (!this.validateKeyword()) {
      return;
    }
    
    const params = {keyword: this.keyword, pageNo, rowCount};
    this.loading = true;
    return CaseApi.retrieveDeviceComponentCodes(params)
        .then((res: CaseDeviceComponentCodeDictionaryDialogResponse) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }

          this.values = res.data.listInfo;
        })
        .catch((errMsg) => this.afterRequestFail(errMsg))
        .finally(() => this.loading = false);
  }
  
  public onInput() {
    if (this.isKeywordMaxlengthExceed) {
      this.errMsg = this.$t('message.case.dialog.directInputMaxlengthExceed').toString();
      return;
    }

    this.onRowClick({
      row: {
        fdaCode: this.keyword,
      }
    });
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showCaseDeviceComponentCodeSelectDialog');
    this.$modal.getEventBus().$off('hideCaseDeviceComponentCodeSelectDialog');
  }
}
